/**
 * Business Unit Hook
 * 
 * Hook to access BusinessUnitContext.
 * NO provider logic, NO context creation - just the hook.
 */

import { useContext } from 'react';
import { BusinessUnitContext } from './BusinessUnit.context';

export function useBusinessUnitContext() {
  const context = useContext(BusinessUnitContext);
  if (!context) {
    throw new Error('useBusinessUnitContext must be used within BusinessUnitProvider');
  }
  return context;
}

